import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-grey-background" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-12" }
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column is-4" }
const _hoisted_6 = { class: "column is-4" }
const _hoisted_7 = { class: "column is-2" }
const _hoisted_8 = { class: "column is-1" }
const _hoisted_9 = { class: "columns" }
const _hoisted_10 = { class: "column is-4" }
const _hoisted_11 = { class: "column is-4" }
const _hoisted_12 = { class: "columns" }
const _hoisted_13 = { class: "column is-4" }
const _hoisted_14 = { class: "column is-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Field, {
              name: "LastName",
              modelValue: _ctx.computedLastNsme,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedLastNsme) = $event))
            }, {
              default: _withCtx(({ field, meta, errorMessage }) => [
                _createVNode(_component_o_field, {
                  label: "Last name",
                  variant: errorMessage ? 'danger' : '',
                  message: errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_input, _mergeProps({
                      placeholder: "Last name",
                      modelValue: _ctx.computedLastNsme,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedLastNsme) = $event))
                    }, field, {
                      maxlength: "50",
                      hasCounter: ""
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["variant", "message"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Field, {
              name: "FirstName",
              modelValue: _ctx.computedFirstNsme,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedFirstNsme) = $event))
            }, {
              default: _withCtx(({ field, meta, errorMessage }) => [
                _createVNode(_component_o_field, {
                  label: "First name",
                  variant: errorMessage ? 'danger' : '',
                  message: errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_input, _mergeProps({
                      placeholder: "First name",
                      modelValue: _ctx.computedFirstNsme,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedFirstNsme) = $event))
                    }, field, {
                      maxlength: "25",
                      hasCounter: ""
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["variant", "message"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Field, {
              name: "MiddleName",
              modelValue: _ctx.computedMiddleInitial,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedMiddleInitial) = $event))
            }, {
              default: _withCtx(({ field, meta, errorMessage }) => [
                _createVNode(_component_o_field, {
                  label: "Middle Initial",
                  variant: errorMessage ? 'danger' : '',
                  message: errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_input, _mergeProps({
                      placeholder: "Middle initial",
                      modelValue: _ctx.computedMiddleInitial,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedMiddleInitial) = $event))
                    }, field, {
                      maxlength: "1",
                      hasCounter: ""
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["variant", "message"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Field, {
              name: "Suffix",
              modelValue: _ctx.computedSuffix,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedSuffix) = $event))
            }, {
              default: _withCtx(({ field, meta, errorMessage }) => [
                _createVNode(_component_o_field, {
                  label: "Suffix",
                  variant: errorMessage ? 'danger' : '',
                  message: errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_input, _mergeProps({
                      placeholder: "Suffix",
                      modelValue: _ctx.computedSuffix,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedSuffix) = $event))
                    }, field, {
                      maxlength: "4",
                      hasCounter: ""
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["variant", "message"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Field, {
              name: "EmailAddress",
              modelValue: _ctx.computedEmailAddress,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedEmailAddress) = $event)),
              ref: "emailAddressInput"
            }, {
              default: _withCtx(({ field, meta, errorMessage }) => [
                _createVNode(_component_o_field, {
                  label: "Email Address",
                  variant: errorMessage ? 'danger' : '',
                  message: errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_input, _mergeProps({
                      placeholder: "Email Address",
                      modelValue: _ctx.computedEmailAddress,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedEmailAddress) = $event))
                    }, field, {
                      icon: "envelope",
                      "icon-right-clickable": "",
                      onIconRightClick: _ctx.clearIconClick,
                      "icon-right": _ctx.computedEmailAddressRightIcon,
                      "icon-right-variant": _ctx.computedEmailAddressRigtIconVariant,
                      maxlength: "200",
                      hasCounter: "",
                      onInput: _cache[9] || (_cache[9] = (event) => _ctx.$emit('emailAddressInput', event))
                    }), null, 16, ["modelValue", "onIconRightClick", "icon-right", "icon-right-variant"])
                  ]),
                  _: 2
                }, 1032, ["variant", "message"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (!_ctx.disableUseridInput)
              ? (_openBlock(), _createBlock(_component_Field, {
                  key: 0,
                  name: "UserID",
                  modelValue: _ctx.computedUserId,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedUserId) = $event)),
                  ref: "userIdInput"
                }, {
                  default: _withCtx(({ field, meta, errorMessage }) => [
                    _createVNode(_component_o_field, {
                      label: "Userid",
                      variant: errorMessage ? 'danger' : '',
                      message: errorMessage
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_input, _mergeProps({
                          placeholder: "Userid",
                          modelValue: _ctx.computedUserId,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedUserId) = $event)),
                          maxlength: "50",
                          hasCounter: "",
                          "icon-right": _ctx.computedUserIdRightIcon,
                          "icon-right-variant": _ctx.computedUserIdRigtIconVariant
                        }, field, {
                          onInput: _cache[12] || (_cache[12] = (event) => _ctx.$emit('useridInput', event))
                        }), null, 16, ["modelValue", "icon-right", "icon-right-variant"])
                      ]),
                      _: 2
                    }, 1032, ["variant", "message"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : (_ctx.disableUseridInput)
                ? (_openBlock(), _createBlock(_component_Field, {
                    key: 1,
                    name: "UserID",
                    modelValue: _ctx.computedUserId,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedUserId) = $event)),
                    ref: "userIdInput"
                  }, {
                    default: _withCtx(({ field, meta }) => [
                      _createVNode(_component_o_field, { label: "Userid" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_input, _mergeProps({
                            placeholder: "Userid",
                            modelValue: _ctx.computedUserId,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedUserId) = $event))
                          }, field, { disabled: "" }), null, 16, ["modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Field, {
              name: "Password",
              modelValue: _ctx.computedPassword,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.computedPassword) = $event)),
              ref: "passwordInput"
            }, {
              default: _withCtx(({ field, meta, errorMessage }) => [
                _createVNode(_component_o_field, {
                  label: "Password",
                  variant: errorMessage ? 'danger' : '',
                  message: errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_input, _mergeProps({
                      modelValue: _ctx.computedPassword,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedPassword) = $event)),
                      classes: errorMessage ? 'input is-danger' : 'input' ,
                      placeholder: "Password"
                    }, field, {
                      type: "password",
                      "password-reveal": "",
                      maxlength: "200",
                      hasCounter: ""
                    }), null, 16, ["modelValue", "classes"])
                  ]),
                  _: 2
                }, 1032, ["variant", "message"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Field, {
              name: "confirmPassword",
              modelValue: _ctx.confirmPassword,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.confirmPassword) = $event)),
              ref: "confirmPasswordInput"
            }, {
              default: _withCtx(({ field, meta, errorMessage }) => [
                _createVNode(_component_o_field, {
                  label: "Confirm Password",
                  variant: errorMessage ? 'danger' : '',
                  message: errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_input, _mergeProps({
                      placeholder: "Confirm Password",
                      modelValue: _ctx.confirmPassword,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.confirmPassword) = $event))
                    }, field, {
                      type: "password",
                      "password-reveal": "",
                      maxlength: "200",
                      hasCounter: ""
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["variant", "message"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}